import { gsap } from "gsap";

class VisualMovie {
  constructor(el) {
    this.dom = {el: el};
    this.dom.container = this.dom.el;
    this.dom.clip = null;
    this.dom.video = this.dom.el.querySelector('[data-js="movie"]');

    // console.log('VisualMovie constructor:', this.dom.video);

    this.init();
  }

  init() {
    this.setVariable();
  }
  
  setVariable() {
    // 動画要素が既に存在するのでsrc設定は不要
    // console.log('Video element found:', this.dom.video);
  }

  // createVideo() {
  //   const tag = `<span class="c-clip" data-js="clip"><video src="${this.src}" data-js="movie" loop muted playsinline></video></span>`;
  //   this.dom.container.insertAdjacentHTML('beforeend', tag);
  //   this.dom.clip = document.querySelector('[data-js="clip"]')
  //   this.dom.video = document.querySelector('[data-js="movie"]')
  // }
  
  onPlaying() {
    // console.log('onPlaying called, video element:', this.dom.video);
    
    if (!this.dom.video) {
      // console.error('Video element not found');
      return;
    }

    // 動画を再生
    this.dom.video.play()
      .then(() => {
        // console.log('Video started playing successfully');
      })
      .catch((error) => {
        // console.error('Video play failed:', error);
        // エラー時の代替処理は一旦コメントアウト
        // const cover = `<span class="c-clip"><img src="${this.dir}/assets/img/home/cover.jpg" alt="" decoding="async"></span>`;
        // this.dom.container.insertAdjacentHTML('beforeend', cover);
        // this.dom.container.removeChild(this.dom.clip);
      });
  }

  onPause() {
    // console.log('onPause called');
    if (this.dom.video) {
      this.dom.video.pause();
    }
  }
}

export default VisualMovie